const Patents = () => {
  const patents = [
    {
      type: '특허',
      title: '광학 센싱 기반 수도미터기',
      number: '특허 제10-2023-0001234호',
      date: '2023.03.15',
      description: '광학 센서를 이용한 비접촉식 수량 측정 기술',
      icon: 'ri-lightbulb-line',
      color: 'from-teal-500 to-teal-600',
    },
    {
      type: '특허',
      title: 'IoT 연동 스마트 계량 시스템',
      number: '특허 제10-2023-0005678호',
      date: '2023.06.20',
      description: '실시간 데이터 전송 및 원격 모니터링 시스템',
      icon: 'ri-wifi-line',
      color: 'from-teal-600 to-cyan-600',
    },
    {
      type: '특허 출원',
      title: '부정사용 방지 알고리즘',
      number: '출원 제10-2024-0001111호',
      date: '2024.01.10',
      description: 'AI 기반 이상 패턴 감지 및 자동 알림 시스템',
      icon: 'ri-shield-check-line',
      color: 'from-cyan-500 to-cyan-600',
    },
    {
      type: '인증',
      title: 'KC 인증 (국가통합인증)',
      number: 'KC-REM-ABC12345',
      date: '2023.08.30',
      description: '전기용품 및 생활용품 안전관리법 적합 인증',
      icon: 'ri-award-line',
      color: 'from-cyan-600 to-teal-700',
    },
  ];

  const certifications = [
    {
      name: 'ISO 9001',
      description: '품질경영시스템 인증',
      icon: 'ri-medal-line',
    },
    {
      name: 'ISO 14001',
      description: '환경경영시스템 인증',
      icon: 'ri-leaf-line',
    },
    {
      name: 'OIML R49',
      description: '국제법정계량기구 인증',
      icon: 'ri-global-line',
    },
    {
      name: 'CE 마크',
      description: '유럽 안전 규격 인증',
      icon: 'ri-checkbox-circle-line',
    },
  ];

  const techAdvantages = [
    {
      title: '기술 우위성',
      items: [
        '국내 최초 광학 센싱 기술 적용',
        '99.9% 이상의 정확도 보장',
        '10년 이상 장기 사용 가능',
      ],
    },
    {
      title: '경쟁력',
      items: [
        '기존 제품 대비 30% 가격 경쟁력',
        '납 성분 0% 친환경 소재',
        '실시간 데이터 관리 시스템',
      ],
    },
    {
      title: '확장성',
      items: [
        '가스/전기 미터기 적용 가능',
        '스마트시티 플랫폼 연동',
        '빅데이터 분석 기능 탑재',
      ],
    },
  ];

  return (
    <section id="patents" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 섹션 헤더 */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block px-5 py-2 bg-teal-50 border border-teal-200 rounded-full mb-4">
            <span className="text-teal-600 text-xs md:text-sm font-bold uppercase tracking-wider">Patents &amp; Certifications</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-gray-900 mb-3 md:mb-4">
            특허 및 기술 인증
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-3xl mx-auto font-medium">
            독자적인 기술력과 국내외 인증을 통해 제품의 우수성을 입증합니다
          </p>
        </div>

        {/* 특허 목록 */}
        <div className="mb-12 md:mb-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
            {patents.map((patent, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-xl md:rounded-2xl p-5 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 group"
              >
                <div className="flex items-start gap-4 md:gap-6">
                  <div
                    className={`w-12 md:w-16 h-12 md:h-16 bg-gradient-to-br ${patent.color} rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}
                  >
                    <i className={`${patent.icon} text-2xl md:text-3xl text-white`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="inline-block px-2 md:px-3 py-0.5 md:py-1 bg-teal-100 text-teal-700 rounded-full text-[10px] md:text-xs font-bold mb-2 md:mb-3">
                      {patent.type}
                    </div>
                    <h3 className="text-base md:text-xl font-bold text-gray-900 mb-1 md:mb-2">
                      {patent.title}
                    </h3>
                    <p className="text-xs md:text-sm text-gray-600 mb-1 md:mb-2 truncate">
                      {patent.number}
                    </p>
                    <p className="text-xs md:text-sm text-gray-500 mb-2 md:mb-3">
                      등록일: {patent.date}
                    </p>
                    <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                      {patent.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 인증 현황 */}
        <div className="mb-12 md:mb-20">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 md:mb-8 text-center">
            보유 인증 현황
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
            {certifications.map((cert, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-4 md:p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-200 text-center group"
              >
                <div className="w-12 md:w-16 h-12 md:h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${cert.icon} text-xl md:text-2xl text-white`}></i>
                </div>
                <h4 className="text-sm md:text-lg font-bold text-gray-900 mb-1 md:mb-2">
                  {cert.name}
                </h4>
                <p className="text-[10px] md:text-sm text-gray-600">{cert.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 기술 우위성 */}
        <div>
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 md:mb-8 text-center">
            기술 우위성 및 경쟁력
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
            {techAdvantages.map((advantage, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-xl md:rounded-2xl p-5 md:p-8 border border-teal-100"
              >
                <h4 className="text-base md:text-xl font-bold text-gray-900 mb-4 md:mb-6 pb-3 md:pb-4 border-b-2 border-teal-200">
                  {advantage.title}
                </h4>
                <ul className="space-y-3 md:space-y-4">
                  {advantage.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 md:gap-3">
                      <div className="w-5 md:w-6 h-5 md:h-6 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-xs md:text-sm"></i>
                      </div>
                      <span className="text-xs md:text-sm text-gray-700 leading-relaxed">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Patents;
